import * as React from "react";
import { useInput } from "react-admin";
import { TextField, Typography, Button, IconButton } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";

export function ContentTab({ source }) {
  const {
    input: { value, onChange },
  } = useInput({ source });

  const content = value || {
    introduction: { title: "About this program", description: "" },
    competencies: { title: "What you'll learn", skills: [] },
    needs: { title: "What you'll need", description: "" },
  };

  const updateContent = (newContent) => {
    onChange(newContent);
  };

  const updateIntroduction = (field, val) => {
    updateContent({
      ...content,
      introduction: { ...content.introduction, [field]: val },
    });
  };

  const updateCompetencies = (field, val) => {
    updateContent({
      ...content,
      competencies: { ...content.competencies, [field]: val },
    });
  };

  const updateNeeds = (field, val) => {
    updateContent({
      ...content,
      needs: { ...content.needs, [field]: val },
    });
  };

  const addSkill = () => {
    const skills = [...(content.competencies?.skills || []), ""];
    updateCompetencies("skills", skills);
  };

  const updateSkill = (index, val) => {
    const skills = [...(content.competencies?.skills || [])];
    skills[index] = val;
    updateCompetencies("skills", skills);
  };

  const removeSkill = (index) => {
    const skills = (content.competencies?.skills || []).filter(
      (_, i) => i !== index
    );
    updateCompetencies("skills", skills);
  };

  return (
    <div style={{ maxWidth: 700 }}>
      {/* Introduction */}
      <Typography variant="h6" gutterBottom>
        Introduction
      </Typography>
      <TextField
        label="Title"
        value={content.introduction?.title || ""}
        onChange={(e) => updateIntroduction("title", e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Description"
        value={content.introduction?.description || ""}
        onChange={(e) => updateIntroduction("description", e.target.value)}
        fullWidth
        multiline
        rows={3}
        margin="normal"
      />

      {/* Competencies */}
      <Typography variant="h6" gutterBottom style={{ marginTop: 24 }}>
        Competencies
      </Typography>
      <TextField
        label="Title"
        value={content.competencies?.title || ""}
        onChange={(e) => updateCompetencies("title", e.target.value)}
        fullWidth
        margin="normal"
      />
      <Typography variant="subtitle2" gutterBottom>
        Skills
      </Typography>
      {(content.competencies?.skills || []).map((skill, skillIdx) => (
        <div
          key={`skill-${skillIdx}`} // eslint-disable-line react/no-array-index-key
          style={{ display: "flex", alignItems: "center", marginBottom: 8 }}
        >
          <TextField
            value={skill}
            onChange={(e) => updateSkill(skillIdx, e.target.value)}
            fullWidth
            size="small"
          />
          <IconButton size="small" onClick={() => removeSkill(skillIdx)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </div>
      ))}
      <Button
        size="small"
        startIcon={<AddIcon />}
        onClick={addSkill}
        style={{ marginTop: 4 }}
      >
        Add Skill
      </Button>

      {/* Needs */}
      <Typography variant="h6" gutterBottom style={{ marginTop: 24 }}>
        What You&apos;ll Need
      </Typography>
      <TextField
        label="Title"
        value={content.needs?.title || ""}
        onChange={(e) => updateNeeds("title", e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Description"
        value={content.needs?.description || ""}
        onChange={(e) => updateNeeds("description", e.target.value)}
        fullWidth
        multiline
        rows={3}
        margin="normal"
      />
    </div>
  );
}
